import { Outlet } from 'react-router-dom';
import clsx from 'clsx';
import { useUIStore } from '@/stores/ui';
import Sidebar from './Sidebar';
import Header from './Header';

export default function DashboardLayout() {
  const { sidebarCollapsed } = useUIStore();

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div
        className={clsx(
          'transition-all duration-300 ease-in-out',
          // No margin on mobile since sidebar overlays
          'ml-0',
          // Desktop margins based on collapsed state
          sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'
        )}
      >
        {/* Header */}
        <Header />

        {/* Page Content */}
        <main className="p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
